import { useTranslation } from 'react-i18next';

import { ListHeader } from '../../../ListHeader/ListHeader';
import { useViewportType } from '../../../utils/useViewportType';

import { LoginThumbnail } from './LoginThumbnail/LoginThumbnail';

import * as styles from './LoginList.module.scss';

const LoginList = () => {
  const { isMobile } = useViewportType();
  const { t } = useTranslation();
  const headerText = t('Keep where you left off');

  return (
    <>
      <ListHeader headerContent={headerText} />
      {isMobile && (
        <div className={styles.mobileContainer}>
          <LoginThumbnail variant="default" />
        </div>
      )}
      {!isMobile && (
        <div className={styles.container}>
          <LoginThumbnail variant="default" />
          <LoginThumbnail variant="empty" />
          <LoginThumbnail variant="empty" />
          <LoginThumbnail variant="empty" />
        </div>
      )}
    </>
  );
};

export { LoginList };
